import { lazy } from "react";

import {
  DASHBOARD_TASKS,
  DASHBOARD_TILES,
  defineModule,
  VENDOR_ONBOARDING,
  VENDOR_PICKER,
} from "@motolynk/app-core";

import { VendorsTile, VendorTasks } from "./admin/dashboard";
import { VendorPicker } from "./admin/VendorPicker";
import { StoreStatusTile } from "./vendor/dashboard";
import en from "./i18n/en.json";

const OnboardingFlow = lazy(() => import("./vendor/OnboardingFlow"));

export const vendorsModule = defineModule({
  name: "vendors",
  label: "Vendors",
  requires: [
    "core",
    "geo",
    "accounts",
    "configuration",
    "audit",
    "medialib",
    "notifications",
    "catalog",
  ],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "vendors",
        permission: "vendors.view_vendor",
        page: () => import("./admin/VendorsPage"),
      },
      {
        path: "vendors/platform",
        permission: "vendors.view_vendor",
        page: () => import("./admin/PlatformVendorPage"),
      },
      {
        path: "vendors/:uid",
        permission: "vendors.view_vendor",
        page: () => import("./admin/VendorDetailPage"),
      },
    ],
    nav: [
      {
        id: "vendors",
        group: "business",
        label: "vendors:nav.vendors",
        icon: "store",
        to: "/vendors",
        permission: "vendors.view_vendor",
        order: 5,
      },
      {
        id: "our-store",
        group: "business",
        label: "vendors:nav.ourStore",
        icon: "package",
        to: "/vendors/platform",
        permission: "vendors.view_vendor",
        order: 6,
      },
    ],
    slots: {
      [DASHBOARD_TILES]: [
        { id: "vendors", permission: "vendors.view_vendor", order: 30, component: VendorsTile },
      ],
      [DASHBOARD_TASKS]: [
        { id: "vendors", permission: "vendors.approve_vendor", order: 10, component: VendorTasks },
      ],
      [VENDOR_PICKER]: [
        {
          id: "vendors",
          permission: "vendors.view_vendor",
          component: VendorPicker,
        },
      ],
    },
  },
  vendor: {
    // permissions here are the store team-role codes from /vendor/me (apps/vendors/permissions.py)
    routes: [
      {
        path: "store",
        permission: "store.view",
        page: () => import("./vendor/store/StoreSettingsPage"),
      },
      { path: "team", permission: "team.view", page: () => import("./vendor/team/TeamPage") },
    ],
    nav: [
      {
        id: "store-settings",
        group: "store",
        label: "vendors:nav.store",
        icon: "store",
        to: "/store",
        permission: "store.view",
        order: 1,
      },
      {
        id: "team",
        group: "store",
        label: "vendors:nav.team",
        icon: "users",
        to: "/team",
        permission: "team.view",
        order: 2,
      },
    ],
    slots: {
      [VENDOR_ONBOARDING]: [{ id: "vendors", component: OnboardingFlow }],
      [DASHBOARD_TILES]: [
        { id: "store", permission: "store.view", order: 10, component: StoreStatusTile },
      ],
    },
  },
});
